export const APPLICANT_COOKIE_NAME = 'nu__prospect_types';
